import { IEmailSettings } from "../interfaces/models/IEmailSettings";
import Axios from "../utils/axios";

const axios = new Axios();

function messageFromAxiosError(error: unknown, fallback: string): string {
  const body = (error as { response?: { data?: unknown }; message?: string })?.response?.data;
  if (typeof body === "string" && body.trim()) {
    return body.trim();
  }
  if (body && typeof body === "object" && typeof (body as { message?: unknown }).message === "string") {
    return (body as { message: string }).message;
  }
  const message = (error as { message?: string })?.message;
  return message || fallback;
}

export async function getEmailSettings(): Promise<IEmailSettings> {
  try {
    const response = await axios.Get("/settings/email");
    return response.data;
  } catch (error: unknown) {
    throw new Error(messageFromAxiosError(error, "Could not load email settings."));
  }
}

export async function saveEmailSettings(settings: IEmailSettings): Promise<IEmailSettings> {
  try {
    const response = await axios.Put("/settings/email", settings);
    return response.data;
  } catch (error: unknown) {
    throw new Error(messageFromAxiosError(error, "Could not save email settings."));
  }
}
